import React from "react";
import { useNavigate } from "react-router-dom";
import { TypeOfApplicationEnum } from "../../utils/enum";
import moment from "moment";
import { dashboardNavConfig } from "./LabGridRow";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";
const CopyLabGridRow = (data: any, sno: number) => {
  const navigate = useNavigate();
  const { message } = notify();
  const navToSamples = (appNum: string, purposeCode?: string) => {
    if (!purposeCode) {
      message(NotifyType.Error, "Purpose code is Empty");
      return;
    }
    navigate(
      `/${dashboardNavConfig[purposeCode]}?an=${appNum}&type=${TypeOfApplicationEnum.submit}`
    );
  };

  return (
    <tr>
      <td>{data?.sno || ""}</td>

      <td>{data?.data?.purposeCode || ""}</td>
      <td>
        {data?.data?.showCopyButton === 1 && (
        <a
          href=""
          onClick={() =>
            navToSamples(data?.data?.applicationNumber, data?.data?.purposeCode)
          }
        >
          {data?.data?.applicationNumber || ""}
        </a>
        )}
        {data?.data?.showCopyButton === 0 && (data?.data?.applicationNumber || "")}
      </td>

      <td>{data?.data?.requestorName || ""}</td>

      <td>{moment(data?.data?.applicationDate).format("DD/MM/yyyy")}</td>
    </tr>
  );
};

export default CopyLabGridRow;
